<template>
  <div v-if="serviceLoaded">
    <ServiceManagerEditor v-if="needsNewEditor" />
    <ServiceManagerClassicEditor v-else />
  </div>
</template>

<script setup lang="ts">
import ReservationService from '@/grpc-api/model/reservation-service';
import router from '@/router';
import { loadStoreModule, unloadStoreModule } from '@/services/module-loader';
import { performDispatchAction } from '@/services/vue-utils';
import ServiceManagerStore from '@/store/service-manager-store';
import store from '@/store/store';
import {
  getCurrentInstance, onBeforeUnmount, onMounted, ref, computed,
} from 'vue';
import ServiceManagerClassicEditor from './ServiceManagerClassicEditor.vue';
import ServiceManagerEditor from './ServiceManagerEditor.vue';

const IS_SVCMGR_INTERNAL_BUILD = false;
const serviceLoaded = ref(false);
const service = ref<ReservationService| undefined>(new ReservationService());
const needsNewEditor = computed(
  () => IS_SVCMGR_INTERNAL_BUILD
  || (service.value?.translations.length ?? 0) > 0
  || router.currentRoute.query.action === 'copy'
  || router.currentRoute.params.id === 'new',
);

const reset = async () => {
  const route = router.currentRoute;

  const id = Number(route.params.id) || 0;
  service.value = store.state.serviceManager.services.find((o) => o.id === id);

  serviceLoaded.value = true;
};

const load = async () => {
  if (!store.getters.isServiceManagerLoaded) {
    await performDispatchAction('loadServiceManager', {}, { streamLoad: true }) as ReservationService[] | null;
  }
  reset();
};

onBeforeUnmount(() => {
  unloadStoreModule(
    getCurrentInstance()?.proxy!,
    'serviceManager',
    async () => { store.dispatch('resetServiceManager'); },
  );
});

onMounted(() => {
  loadStoreModule(getCurrentInstance()?.proxy!, 'serviceManager', ServiceManagerStore, async () => { load(); });
});

</script>
